import type { ReactNode, SVGProps } from "react";

type IconName =
  | "alert"
  | "check"
  | "clock"
  | "down"
  | "finance"
  | "menu"
  | "options"
  | "orders"
  | "pencil"
  | "plus"
  | "publish"
  | "refresh"
  | "signal"
  | "store"
  | "trash"
  | "up";

const paths: Record<IconName, ReactNode> = {
  alert: <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />,
  check: <path d="m5 12 4 4L19 6" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  down: <path d="m6 9 6 6 6-6" />,
  finance: (
    <>
      <path d="M4 7h16M5 7l1-3h12l1 3M6 11h12M7 11v7m5-7v7m5-7v7M4 20h16" />
    </>
  ),
  menu: (
    <>
      <path d="M5 6h14M5 12h14M5 18h14" />
      <circle cx="8" cy="6" r="1" />
    </>
  ),
  options: (
    <>
      <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" />
    </>
  ),
  orders: (
    <>
      <path d="M6 3h12v18l-3-2-3 2-3-2-3 2Z" />
      <path d="M9 8h6M9 12h6" />
    </>
  ),
  pencil: (
    <>
      <path d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  publish: (
    <>
      <path d="M22 2 11 13" />
      <path d="M22 2 15 22l-4-9-9-4Z" />
    </>
  ),
  refresh: (
    <>
      <path d="M20 6v5h-5" />
      <path d="M18 17a8 8 0 1 1 1.5-8" />
    </>
  ),
  signal: (
    <>
      <path d="M4 17h2M9 13h2v4H9zM14 9h2v8h-2zM19 5h1v12h-1z" />
    </>
  ),
  store: (
    <>
      <path d="M4 10v10h16V10M3 10l2-6h14l2 6" />
      <path d="M3 10a3 3 0 0 0 5 2 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3 3 0 0 0 5-2M9 20v-5h6v5" />
    </>
  ),
  trash: (
    <>
      <path d="M3 6h18M8 6V4h8v2M19 6v14H5V6M10 11v6M14 11v6" />
    </>
  ),
  up: <path d="m18 15-6-6-6 6" />,
};

export function Icon({ name, ...props }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}

export function Brand() {
  return (
    <span className="brand" aria-label="GoBro" role="img">
      <span className="brand-g">G</span>
      <span className="brand-mark">
        <span />
      </span>
      <span className="brand-bro">Bro</span>
    </span>
  );
}
